import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id EBB8E627-2F7B-4B33-94C6-440DD5C293E4
 * name send-variant
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send-variant.svg
 * tags
 */
export const SendVariantIcon = createSvgIcon(<><path d="M3 20V14L11 12L3 10V4L22 12Z" /></>, 'SendVariantIcon');
export default SendVariantIcon